var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendartick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33203 2.33008V5.83008M18.6654 2.33008V5.83008M4.08203 10.6017H23.9154M25.6654 22.1634C25.6654 23.0384 25.4204 23.8667 24.9887 24.5667C24.5774 25.258 23.9932 25.8302 23.2936 26.2271C22.594 26.6239 21.803 26.8317 20.9987 26.8301C19.8204 26.8301 18.747 26.3984 17.9304 25.6634C17.5687 25.3601 17.2537 24.9867 17.0087 24.5667C16.5646 23.8439 16.3303 23.0118 16.332 22.1634C16.332 19.5851 18.4204 17.4967 20.9987 17.4967C22.3987 17.4967 23.647 18.1151 24.4987 19.0834C25.249 19.9342 25.6637 21.0291 25.6654 22.1634Z",
    stroke: "#F0973E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1797 22.1624L20.3347 23.3174L22.8197 21.019",
    stroke: "#F0973E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 9.9135V19.0835C23.6483 18.1152 22.4 17.4968 21 17.4968C18.4217 17.4968 16.3333 19.5852 16.3333 22.1635C16.3333 23.0385 16.5783 23.8668 17.01 24.5668C17.255 24.9868 17.57 25.3602 17.9317 25.6635H9.33333C5.25 25.6635 3.5 23.3302 3.5 19.8302V9.9135C3.5 6.4135 5.25 4.08017 9.33333 4.08017H18.6667C22.75 4.08017 24.5 6.4135 24.5 9.9135Z",
    stroke: "#F0973E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9936 15.9878H14.0053M9.67578 15.9878H9.68745M9.67578 19.4878H9.68745",
    stroke: "#F0973E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendartick);
export default __webpack_public_path__ + "static/media/calendartick.28b8bd68c8da964b073e62b1cf20c3a9.svg";
export { ForwardRef as ReactComponent };